import React from "react";
import { useResponsiveBelowLg } from "src/hooks";
import { HeaderBar } from "./HeaderBar/HeaderBar";
import { HeaderBarBelowLg } from "./HeaderBar/HeaderBar.belowLg";

export const Header = () => {
  const isBelowLg = useResponsiveBelowLg();

  return isBelowLg ? <HeaderBarBelowLg /> : <HeaderBar />;
};
